"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindPayload = FindPayload;
exports.SureFindPayload = SureFindPayload;
function FindPayload(payloads, uuid) {
    return payloads.find((payload) => payload.uuid === uuid);
}
function SureFindPayload(payloads, uuid) {
    return FindPayload(payloads, uuid);
}
